import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC } from 'react';

import CloseIcon from './assets/close.inline.svg';
import MenuIcon from './assets/menu.inline.svg';

interface Props extends StyleProps, TestIdProps {
  icon?: 'menu' | 'close';
  onClick?: () => void;
}

export const MenuBtn: FC<Props> = ({ testId, className, style, icon = 'menu', onClick }) => (
  <button
    data-testid={testId}
    className={mc('py-3', 'w-12', 'flex justify-center', className)}
    style={style}
    role="button"
    onClick={onClick}
  >
    {icon === 'menu' && <MenuIcon />}
    {icon === 'close' && <CloseIcon />}
  </button>
);

export type MenuBtnProps = Props;
export default MenuBtn;
